import { Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { OperativeUnitDto } from "@/core/features/operative-units/operative-unit.dto";

export class BusinessUnitDto extends BaseEntityDto {
  name: string;

  @Type(() => OperativeUnitDto)
  operativeUnits?: OperativeUnitDto[];

  toString(): string {
    return this.name;
  }
}
